import WIconButton from "../wicon-button/WIconButton";
import WTypography from "../wtypography/WTypography";

interface IProfileInfoEditElementProps {
  title: string;
  subTitle: string;
  onClick?: () => void;
}

export const WProfileInfoEditElement = ({
  title,
  subTitle,
  onClick,
}: IProfileInfoEditElementProps) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between px-3 py-4 transition-all bg-white rounded-md shadow-sm cursor-pointer hover:shadow-md active:scale-95"
    >
      <div className="flex flex-col">
        <WTypography text={title} type="medium" />
        <WTypography text={subTitle} type="small" />
      </div>
      <WIconButton type="white" icon="arrow-right" />
    </div>
  );
};

export default WProfileInfoEditElement;
